import React from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";

const Wrapper = styled.nav`
	display: flex;
	align-items: center;
	margin-left: 16px;
`;

const MenuLink = styled.a`
	margin-right: 16px;
	margin-left: 16px;
	color: #fff;
	font-weight: 500;
	transition: 0.2s color ease-in-out;

	&:hover,
	&:active,
	&:focus {
		color: ${({theme}) => theme.global.header_hover_color};
	}
`;

const LINKS = [
	{title: "header.fifa.originals", href: ""},
	{title: "header.fifa.news", href: ""},
	{title: "header.fifa.matches", href: ""},
	{title: "header.fifa.live", href: ""},
	{title: "header.fifa.womens", href: ""},
	{title: "header.fifa.archive", href: ""},
];

export const MenuLinks: React.FC = () => {
	const {t} = useTranslation();

	return (
		<Wrapper>
			{LINKS.map((link) => (
				<MenuLink key={link.title} href={link.href}>
					{t(link.title)}
				</MenuLink>
			))}
		</Wrapper>
	);
};
